// FUNCTIONS FOR NORMALIZING AND DENORMALIZING PHONE NUMBERS

export function normalizePhone(value) {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (value.length > 0) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    if (cvLength < 11) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`
    return `${currentValue.slice(0, 1)} (${currentValue.slice(1, 4)}) ${currentValue.slice(4, 7)}-${currentValue.slice(7, 11)}`;
  }
}

export function deNormalizePhone(value) {
  if (!value) return value;
  const denorm = value.replace(/[^\d]/g, '');

  return denorm
}

export function handleNorm(e, id) {
  var phone = normalizePhone(e)
  document.getElementById(id).value = phone
}

export function handleDeNorm(e) {
  var phone = deNormalizePhone(e)
  return phone
}